import { useState, useRef, useEffect } from "react";
import type { ExtraButton, TableState } from "./types";
import { getExtraButtonHandler } from "./extra_buttons";
import { DotsGridIcon, ChevronIcon } from "./icons";

interface Props {
  buttons: ExtraButton[];
  tableState: TableState;
}

export default function ExtraButtons({ buttons, tableState }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleItemClick = (btn: ExtraButton) => {
    setOpen(false);
    if (btn.handler) {
      const handler = getExtraButtonHandler(btn.handler);
      if (handler) {
        handler({
          source: "extra_button",
          actionName: btn.handler,
          selectedRows: [],
          optionValues: {},
          config: btn.handler_config,
          tableState,
        });
        return;
      }
    }
    if (btn.url) {
      window.location.href = btn.url;
    }
  };

  return (
    <div className="lt-extra-buttons" ref={ref}>
      <button
        type="button"
        className="lt-extra-buttons__toggle rd-btn rd-btn--outline rd-btn--secondary rd-btn--medium"
        onClick={() => setOpen((v) => !v)}
      >
        <DotsGridIcon />
        <span className="lt-extra-buttons__label">Действия</span>
        <span className="lt-extra-buttons__divider" />
        <ChevronIcon className={`lt-extra-buttons__chevron${open ? " lt-extra-buttons__chevron--open" : ""}`} />
      </button>

      {open && (
        <div className="lt-extra-buttons__menu">
          {buttons.map((btn, i) => (
            <button
              key={i}
              type="button"
              className="lt-extra-buttons__item"
              onClick={() => handleItemClick(btn)}
            >
              {btn.icon && <i className={`${btn.icon} lt-extra-buttons__item-icon`} />}
              <span>{btn.title}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
